import { useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Person, Eye } from '@teo/components/icons';

const MotivationalLP = ({ trainingDetail, handleChangeTraining }) => {
  const { t } = useTranslation();
  const [text, setText] = useState(trainingDetail?.motivationalMessage || '');
  const [showDropdown, setShowDropdown] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const inputRef = useRef(null);

  const variables = [
    {
      key: 'First name',
      value: ' {{first_name}} ',
      icon: <Person className="h-5 w-5" />,
    },
    {
      key: 'Last name',
      value: ' {{last_name}} ',
      icon: <Person className="h-5 w-5" />,
    },
    {
      key: 'Average score %',
      value: ' {{average_score}} ',
      icon: <Eye className="h-5 w-5" />,
    },
    {
      key: 'Team name',
      value: ' {{team_name}} ',
      icon: <Eye className="h-5 w-5" />,
    },
  ];

  const handleTextChange = (e) => {
    const value = e.target.value;
    setText(value);
    const cursorPos = inputRef.current.selectionStart;
    const beforeCursorText = value.slice(0, cursorPos);
    const lastSlashIndex = beforeCursorText.lastIndexOf('/');
    if (lastSlashIndex !== -1 && cursorPos === lastSlashIndex + 1) {
      setShowDropdown(true);
    } else {
      setShowDropdown(false);
    }
  };

  const handleVariableSelect = (variable) => {
    const currentText = text;
    const cursorPos = inputRef.current.selectionStart;

    const beforeCursorText = currentText.slice(0, cursorPos);
    const lastSlashIndex = beforeCursorText.lastIndexOf('/');

    if (lastSlashIndex !== -1) {
      const newText =
        currentText.slice(0, lastSlashIndex) +
        variable.value +
        currentText.slice(cursorPos);

      setText(newText);
      setShowDropdown(false);

      const newCursorPos = lastSlashIndex + variable.value.length;
      setTimeout(() => {
        inputRef.current.setSelectionRange(newCursorPos, newCursorPos);
        inputRef.current.focus();
      }, 0);
    } else {
      const newText =
        currentText.slice(0, cursorPos) +
        variable.value +
        currentText.slice(cursorPos);
      setText(newText);
      setShowDropdown(false);
      setTimeout(() => {
        inputRef.current.setSelectionRange(
          cursorPos + variable.value.length,
          cursorPos + variable.value.length
        );
        inputRef.current.focus();
      }, 0);
    }
  };

  const replaceVariablesWithSpan = (inputString, variables) => {
    return inputString.split(/({{\s*[^}]+\s*}})/g).map((part, index) => {
      const match = part.match(/{{\s*([^}]+)\s*}}/);
      if (match) {
        const variable = variables.find(
          (v) => v.value.trim() === `{{${match[1]}}}`
        );
        if (variable) {
          return (
            <span
              key={index}
              className="inline-block rounded-sm bg-[#1E1E2014] px-2 py-[1px] text-sm font-medium text-grey-08"
            >
              {variable.key}
            </span>
          );
        }
      }
      return part;
    });
  };

  return (
    <div
      style={{ position: 'relative' }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {isHovered || isFocused ? (
        <>
          <textarea
            ref={inputRef}
            value={text}
            onChange={handleTextChange}
            onFocus={() => setIsFocused(true)}
            onBlur={() => {
              setIsFocused(false);
              setTimeout(() => {
                setShowDropdown(false);
                setIsHovered(false);
                handleChangeTraining &&
                  handleChangeTraining({ motivationalMessage: text });
              }, 200);
            }}
            placeholder={t(
              'pages.learning_path.settings.placeholder_motivational_message'
            )}
            className="inputWhiteBg h-auto min-h-[150px] w-full resize-none rounded-md border border-solid border-transparent bg-white px-3 py-2 text-sm leading-[1.8] text-grey-08 !shadow-none outline outline-2 !outline-offset-0 outline-transparent !ring-0 placeholder:text-sm placeholder:leading-[1.8] placeholder:text-grey-04 enabled:bg-grey-transparent-01 enabled:hover:border-grey-transparent-03 enabled:hover:bg-white enabled:hover:outline-grey-transparent-01 enabled:focus:border-secondary-04 enabled:focus:bg-white enabled:focus:outline-secondary-01 enabled:active:border-secondary-04 enabled:active:bg-white enabled:active:outline-secondary-01 disabled:border-grey-03 disabled:bg-grey-transparent-02"
          />

          {showDropdown && (
            <div
              style={{
                bottom: '105%',
                left: 0,
                zIndex: 1000,
              }}
              className="absolute flex min-w-60 flex-col gap-1 rounded-lg bg-white p-1 drop-shadow-m"
            >
              {variables.map((item) => (
                <div
                  key={item.value}
                  onClick={() => {
                    // handleMouseLeave();
                    handleVariableSelect(item);
                  }}
                  className="flex cursor-pointer gap-2 p-2 text-sm text-black hover:bg-secondary-01"
                >
                  {item?.icon}
                  {item.key}
                </div>
              ))}
            </div>
          )}
        </>
      ) : (
        <div className="w-full">
          <p className="min-h-[150px] w-full border border-white px-3 py-2 text-sm leading-[1.8] text-grey-08">
            {text ? (
              replaceVariablesWithSpan(text, variables)
            ) : (
              <span className="text-grey-04">
                {t(
                  'pages.learning_path.settings.placeholder_motivational_message'
                )}
              </span>
            )}
          </p>
        </div>
      )}
    </div>
  );
};

export default MotivationalLP;
